import { ColDef } from "ag-grid-community";
import { Task } from "@/services/cloudchipr.api";

export const forecastedEOMComparatorFn: ColDef<Task>["comparator"] = (
  _,
  __,
  nodeA,
  nodeB,
) => {
  const current = nodeA?.data?.target?.forecasted_end_of_month;
  const next = nodeB?.data?.target?.forecasted_end_of_month;

  if (typeof current !== "number") return 1;
  if (typeof next !== "number") return -1;

  return current > next ? 1 : -1;
};
